import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ASSETS } from "../lib/assets";

export const FinalCTA = ({ onCta }) => {
    return (
        <section
            id="contact"
            data-testid="final-cta-section"
            className="relative py-28 md:py-40 overflow-hidden bg-black"
        >
            <video
                src={ASSETS.heroVideo}
                autoPlay
                loop
                muted
                playsInline
                className="absolute inset-0 w-full h-full object-cover opacity-20"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black" />
            <div
                className="absolute inset-0 opacity-[0.04] pointer-events-none"
                style={{
                    backgroundImage:
                        "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
                    backgroundSize: "64px 64px",
                }}
            />

            <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-[11px] font-bold tracking-[0.3em] uppercase text-white/60 mb-6"
                >
                    / Laatste stap
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-[80px] font-bold tracking-tighter leading-[1] text-white"
                >
                    Klaar om jouw vastgoed{" "}
                    <span className="italic font-light text-white/60">
                        professioneler te presenteren?
                    </span>
                </motion.h2>

                <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.15 }}
                    className="mt-8 text-base md:text-xl text-white/70 max-w-xl mx-auto leading-relaxed"
                >
                    Plan vrijblijvend een korte online afspraak. Binnen 24 uur
                    reactie. Geen verplichtingen.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                    className="mt-12"
                >
                    <button
                        data-testid="final-cta-btn"
                        onClick={onCta}
                        className="btn-shine rounded-full bg-white text-black font-semibold px-10 py-5 text-lg transition-all duration-300 hover:bg-neutral-100 hover:scale-[1.03] hover:shadow-[0_20px_50px_-10px_rgba(255,255,255,0.3)] inline-flex items-center gap-2"
                    >
                        <span>Plan mijn gesprek</span>
                        <ArrowUpRight className="w-5 h-5" />
                    </button>
                </motion.div>

                <div className="mt-12 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/50 font-medium">
                    <span>✓ Geen verplichtingen</span>
                    <span>✓ Binnen 24u reactie</span>
                    <span>✓ 100% vrijblijvend</span>
                </div>
            </div>
        </section>
    );
};
